import { Navigate } from 'react-router-dom';
import { Flex, Spinner } from '@chakra-ui/react';
import { useAuth } from 'views/admin/auth/AuthProvider';

/**
 * Rota inicial por perfil:
 *   tecnico   → /admin/tecnico/minhas-os
 *   supervisor → /admin/supervisor/painel
 *   admin      → /admin/admin-panel
 *   cliente    → /admin/cliente/acompanhamento
 */
export function getHomeByRole(role) {
  switch (role) {
    case 'supervisor': return '/admin/validacoes';
    case 'admin':      return '/admin/admin-panel';
    case 'cliente':    return '/admin/cliente/acompanhamento';
    default:           return '/admin/tecnico/minhas-os'; // tecnico + fallback
  }
}

export default function RoleRedirect() {
  const { role, ready } = useAuth();

  if (!ready) {
    return (
      <Flex justify="center" align="center" minH="60vh">
        <Spinner size="xl" color="brand.500" />
      </Flex>
    );
  }

  return <Navigate to={getHomeByRole(role)} replace />;
}
